import { API } from "@/services"

export const SIP_FRIENDS_ENDPOINTS = {
  serverRegisterAgents(params={}){
    return API.Axios.error_capture.v1.request({
      url: `sip-friends/server-register-agents`,
      method: 'GET',
      params,
    })
  },
  list(params={}){
    return API.Axios.error_capture.v1.request({
      url: `sip-friends`,
      method: 'GET',
      params,
    })
  },
}